import {createAsyncThunk, createSlice} from '@reduxjs/toolkit';
import {ContactState} from "../../entity/index.entity";
import {API_URL} from "../../constants";
import {checkResponse} from "../../utils";
export const fetchContact = createAsyncThunk(
    'event/fetchContact',
    async () => {
        const res = await fetch(`${API_URL}/contacts`);
        const items = await checkResponse(res);
        return items;
    }
);

const ContactSlice = createSlice({
    name: 'contactSlice',
    initialState: {
        pageImages: [],
        members: []
    } as ContactState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchContact.fulfilled, (state, action) => {
                state.pageImages = action.payload.page_images;
                state.members = action.payload.members;
            })

    }
});

export default ContactSlice.reducer;